import React from 'react';
import { Action } from '../../../../interfaces/chat.interface';
import './CloseChat.scss';

// @ts-ignore
import peligroIcon from '../../../../assets/icons/CDA/peligro.svg';

interface IProps {
    setChatState: React.Dispatch<Action>;
    setShowCloseChat: () => void;
}

const CloseChat = ({ setChatState, setShowCloseChat }: IProps) => {
    const handleClose = () => {
        setChatState({ type: 'RESET_STATE' });
        setShowCloseChat();
    };

    return (
        <div className="a-closeChat">
            <div className="a-closeChat__modal">
                <img src={peligroIcon} alt="peligro icon" />
                <h3>¿Quieres cerrar este chat?</h3>
                <span>Toda la conversación se perderá</span>
                <div className="buttons">
                    <button
                        onClick={handleClose}
                        className="close"
                        aria-label="Cerrar chat"
                    >
                        Si, cerrar
                    </button>
                    <button
                        onClick={setShowCloseChat}
                        className="cancel"
                        aria-label="Cancelar"
                    >
                        No, regresar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CloseChat;
